import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import MetisMenu from 'metismenujs';
import {isEntitled} from '../store';
import 'metismenujs/dist/metismenujs.css';
import PropTypes from 'prop-types';
import debug from 'debug';
import styled from 'styled-components/macro';

const log = debug('circleblack:menu');

const _Menu = styled.div`
  width: 205px;
  background-color: yellow;
  position: relative;
`;

function menuSort(a, b) {
  let y = a.name.toString().toLowerCase();
  let z = b.name.toString().toLowerCase();
  if (y === 'log out' || z === 'log out') {
    return -1;
  }
  if (y < z) {
    return -1;
  }
  if (y > z) {
    return 1;
  }
  return 0;
}

function buildMenuItem(item) {
  return item.node;
}

class Menu extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.menu = new MetisMenu(this.$el);
  }

  render() {
    const {session} = this.props;

    const menuItems = [
      {
        name: 'Welcome',
        node: <li key={1}>
          <a href='#'>Welcome</a>
          <ul aria-expanded='false'>
            <li>
              <Link to='/management/welcome'>Welcome</Link>
            </li>
            {/*{isEntitled([{group: 'performance', feature: 'core', access: 'r'}])*/}
            {/*&& <li><Link to='/management/welcomeB'>Welcome B</Link></li>}*/}
          </ul>
        </li>,
      },
      {
        name: 'Entitlements',
        node: isEntitled([{group: 'entitlements', feature: 'core', access: 'r'}]) && <li key={2}>
          <a href='#'>Entitlements</a>
          <ul aria-expanded='false'>
            <li>
              <Link to={'/management/entitlements?tab=mapping'}>Roles</Link>
            </li>
            <li>
              <Link to={'/management/entitlements?tab=products'}>Products</Link>
            </li>
            <li>
              <Link to={'/management/entitlements?tab=firms'}>Firms</Link>
            </li>
            <li>
              <Link to={'/management/entitlements?tab=branches'}>Branches</Link>
            </li>
            <li>
              <Link to={'/management/entitlements?tab=users'}>Users</Link>
            </li>
            <li>
              <Link to={'/management/entitlements?tab=userLookup'}>User Lookup</Link>
            </li>
            {isEntitled([{group: 'entitlements', feature: 'config', access: 'u'}])
            && <li><Link to={'/management/entitlements?tab=configuration'}>Configuration</Link></li>}
            {isEntitled([{group: 'entitlements', feature: 'ops', access: 'u'}])
            && <li><Link to={'/management/entitlements?tab=audit'}>Audit</Link></li>}
          </ul>
        </li>,
      },
      {
        name: 'Password Management',
        node: isEntitled([{group: 'users', feature: 'password', access: 'u'}])
          && <li key={3}>
            <Link to={'/management/passwordManagement'}>Password Management</Link>
          </li>,
      },
      {
        name: 'Email Management',
        node: isEntitled([{group: 'ops', feature: 'email', access: 'u'}])
          && <li key={4}>
            <Link to={'/management/emails'}>Email Management</Link>
          </li>,
      },
      {
        name: 'Notification Management',
        node: isEntitled([{group: 'ops', feature: 'notification', access: 'r'}])
          && <li key={6}>
            <Link to={'/management/NotificationManagement'}>Notification Management</Link>
          </li>,
      },
      {
        name: 'Trading',
        node: isEntitled([{group: 'ops', feature: 'trading', access: 'r'}])
          && <li key={7}>
            <Link to={'/management/trading'}>Trading</Link>
          </li>,
      },
      {
        name: 'Salesforce Financial Services',
        node: isEntitled([{group: 'ops', feature: 'sfs', access: 'r'}])
          && <li key={'sfs'}>
            <Link to={'/management/sfs'}>Salesforce Financial Services</Link>
          </li>,
      },
    ];
    log('rendering');
    return (
      <_Menu>
        <ul className='metismenu' ref={el => {this.el = el;}}>
          {session.entitlements.size() && menuItems.sort(menuSort).map(buildMenuItem)}
        </ul>
      </_Menu>
    );
  }
}

const mapStateToProps = state => ({
  session: state.session,
});

export default connect(mapStateToProps, null)(Menu);

Menu.propTypes = {
  session: PropTypes.shape({
    token: PropTypes.string.isRequired,
    entitlements: PropTypes.shape(),
  }).isRequired,
};
